import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { guttageSubStepConfig } from '@/domain/mitarbeiter/features/anlageassistent/context/utils';
import { AnlageassistentContextType } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useGuttageStepSync({
  showGuttageStep,
  anlageassistentState,
  setAnlageassistentState,
}: {
  showGuttageStep: boolean;
  anlageassistentState: AnlageassistentContextType['state'];
  setAnlageassistentState: Dispatch<
    SetStateAction<AnlageassistentContextType['state']>
  >;
}) {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (showGuttageStep !== anlageassistentState.showGuttageStep) {
      form.resetField('abwesenheiten.guttage.guttageBewerten');
      setAnlageassistentState((prev) => {
        if (prev.showGuttageStep) {
          return {
            ...prev,
            showGuttageStep: false,
            steps: prev.steps.map((step) => {
              if (step.key === 'abwesenheiten' && step.type === 'step') {
                return {
                  ...step,
                  subSteps: step.subSteps.filter(
                    (subStep) => subStep.key !== 'abwesenheiten.guttage',
                  ),
                };
              }
              return step;
            }),
          };
        } else {
          return {
            ...prev,
            showGuttageStep: true,
            steps: prev.steps.map((step) => {
              if (step.key === 'abwesenheiten' && step.type === 'step') {
                return {
                  ...step,
                  subSteps: [...step.subSteps, guttageSubStepConfig({ t })],
                };
              }
              return step;
            }),
          };
        }
      });
    }
  }, [
    anlageassistentState.showGuttageStep,
    form,
    setAnlageassistentState,
    showGuttageStep,
    t,
  ]);
}
